import {Pipe, type PipeTransform, inject} from '@angular/core'
import {DomSanitizer} from '@angular/platform-browser'

@Pipe({
  name: 'safe',
})
export class SafePipe implements PipeTransform {
  readonly #sanitizer = inject(DomSanitizer)

  transform(url) {
    return this.#sanitizer.bypassSecurityTrustResourceUrl(url)
  }
}
